import React from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core'
import { SettlementSelection } from '../types'
import { conceptAuditLabel, money, typeLabel } from '../utils'

interface Props {
  conceptCount: number
  executiveName: string
  goalBonus: number
  includeGoal: boolean
  mutating: boolean
  open: boolean
  period: string
  selectedConcepts: SettlementSelection[]
  total: number
  onClose: () => void
  onConfirm: () => void
}

const SettlementConfirmDialog: React.FC<Props> = props => (
  <Dialog open={props.open} onClose={() => !props.mutating && props.onClose()}>
    <DialogTitle>Confirmar liquidación</DialogTitle>
    <DialogContent>
      <Typography>Ejecutivo: {props.executiveName}</Typography>
      <Typography>Período de oficina: {props.period}</Typography>
      <Typography>Conceptos seleccionados: {props.conceptCount}</Typography>
      {props.selectedConcepts.map(concept => (
        <Typography key={`${concept.personId}:${concept.type}`} variant="body2">
          {concept.personName} · {typeLabel[concept.type]} · {money(concept.amount)}
          {conceptAuditLabel(concept.eventDate, concept.eventPeriod, concept.officePeriod)
            ? ` · ${conceptAuditLabel(concept.eventDate, concept.eventPeriod, concept.officePeriod)}`
            : ''}
        </Typography>
      ))}
      <Typography>Bono meta: {props.includeGoal ? money(props.goalBonus) : 'No incluido'}</Typography>
      <Typography variant="h6">Total: {money(props.total)}</Typography>
    </DialogContent>
    <DialogActions>
      <Button disabled={props.mutating} onClick={props.onClose}>
        Cancelar
      </Button>
      <Button color="primary" variant="contained" disabled={props.mutating} onClick={props.onConfirm}>
        {props.mutating ? <CircularProgress size={22} /> : 'Confirmar'}
      </Button>
    </DialogActions>
  </Dialog>
)

export default SettlementConfirmDialog
